import React, { useEffect, useState } from 'react';
import AOS from 'aos'
import 'aos/dist/aos.css'
import './projects.css';
import ProjectCard from '../../components/ProjectCard/ProjectCard';
import RotatingProjectCard from '../../components/Custom/RotatingProjectCard';
const projectsList = require('./projectsList.json');

const Projects = () => {
	const [activeIndex, setActiveIndex] = useState(null);

	useEffect(() => {
		AOS.init({ duration: 500 });
	}, []);

	return (
		<section id='proj'>
			<div className='text-2xl mb-14 font-bai'>
				<span className='text-neon font-extrabold' data-aos="zoom-in-left" data-aos-offset="120">&lt;</span>
				<span data-aos="zoom-in-up" data-aos-offset="120"> My Arts </span>
				<span className='text-neon font-extrabold' data-aos="zoom-in-right" data-aos-offset="120">/ &gt;</span>
			</div>
			<div className="projects">
				{projectsList?.map((item, index) => (
					<ProjectCard key={index} item={item} index={index} />
				))}
			</div>
			<div className="res_projects">
				{projectsList?.map((item, index) => (
					<RotatingProjectCard
						key={index}
						item={item}
						index={index}
						activeIndex={activeIndex}
						setActiveIndex={setActiveIndex}
					/>
				))}
			</div>

		</section >
	);
}

export default Projects;
